// eslint-disable-next-line @retailer-platform/no-restricted-imports
import { useDisclosure } from '@mantine/hooks'

export type ModalProps = {
  isOpen: boolean
  toggle: () => void
  open: () => void
  close: () => void
}

// TODO: add utility hooks from Mantine into TDS, wrapping here for now
export function useModal(): ModalProps {
  const [isOpen, { open, close, toggle }] = useDisclosure(false)
  return { isOpen, toggle, open, close }
}
